/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION MEDIA COMMENTS: STYLES --------------- ++++++++++ */
export default theme => ({
  visibility: {
    '& .sectiongroupv2 > .header': {
      width: '100%'
    }
  }
});
